import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { UserState } from "./profile.state";

export const UserActions = createActionGroup({
  source: 'User Profile',
  events: {
    'User Login': props<{ login: boolean }>(),
    'Get User': props<UserState>(),
    'Update User': props<UserState>(),
    'User Logout': emptyProps(),
  }
})